import { useBaseViewModel } from '@/common';
import { QueryCoursePayload, QueryCoursesOutput } from '@/domains/course/ports/payloads';
import { GetListCourseUsecase } from '@/domains/course/usecases';
import { useState } from 'react';
import { CourseHttpRepository } from '../adapters/repositories';

export default function GetListCourse() {
  const getListCourseUC = new GetListCourseUsecase(new CourseHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [courseData, setCourseData] = useState<QueryCoursesOutput>();

  const actionGetAllCourse = async (payload?: QueryCoursePayload) => {
    await catchAction(async () => {
      const data = await getListCourseUC.run(payload);
      setCourseData(data);
    });
  };

  return {
    loading,
    error,
    courseData,
    actionGetAllCourse,
  };
}
